export default {
  name: 'leads',
  leadList: 'leadList',
  leadProfile: 'leadProfile'
};
